import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, Check, Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { FullSpinner, Empty } from "@/components/States";

const CATS = ["all", "match", "interest", "message", "photo_request", "contact_request", "verification", "subscription", "safety"];
const LABEL = { all: "All", match: "Matches", interest: "Interests", message: "Messages", photo_request: "Photos", contact_request: "Contacts", verification: "Verification", subscription: "Subscription", safety: "Safety" };

export default function Notifications() {
  const nav = useNavigate();
  const [items, setItems] = useState(null);
  const [cat, setCat] = useState("all");

  const load = () => api.get("/notifications").then(({ data }) => setItems(data.notifications));
  useEffect(() => { load(); }, []);
  if (!items) return <FullSpinner />;

  const markAll = async () => { await api.post("/notifications/read"); load(); };
  const del = async (id) => { await api.delete(`/notifications/${id}`); load(); };
  const filtered = cat === "all" ? items : items.filter((n) => (n.type || "").includes(cat.replace("_request", "")));

  return (
    <div className="space-y-5" data-testid="notifications-page">
      <div className="flex items-center justify-between">
        <h1 className="font-serif text-3xl font-bold text-[#58111A]">Notifications</h1>
        <button onClick={markAll} className="btn-outline text-sm" data-testid="mark-all-read"><Check className="w-4 h-4" /> Mark all read</button>
      </div>
      <div className="flex gap-2 overflow-x-auto hide-scrollbar">
        {CATS.map((c) => <button key={c} onClick={() => setCat(c)} className={`chip shrink-0 ${cat === c ? "!bg-[#781826] !text-white !border-[#781826]" : ""}`}>{LABEL[c]}</button>)}
      </div>
      {filtered.length === 0 ? (
        <Empty icon={Bell} title="No notifications" message="You're all caught up. New matches, interests and updates will show here." />
      ) : (
        <div className="space-y-2">
          {filtered.map((n) => (
            <div key={n.id} onClick={() => n.link && nav(n.link)} className={`mj-card p-4 flex items-start gap-3 cursor-pointer ${!n.read ? "border-l-4 border-l-[#C59B27]" : ""}`} data-testid={`notif-${n.id}`}>
              <div className="w-9 h-9 rounded-full bg-[#FAF3E0] flex items-center justify-center text-[#781826] shrink-0"><Bell className="w-4 h-4" /></div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-sm text-[#261A1C]">{n.title}</div>
                <div className="text-sm text-[#605255]">{n.body}</div>
                <div className="text-[11px] text-[#9E7B1B] mt-0.5">{new Date(n.created_at).toLocaleString()}</div>
              </div>
              <button onClick={(e) => { e.stopPropagation(); del(n.id); }} className="text-[#9E7B1B] hover:text-[#BE123C]"><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
